import React, { useState } from "react";
import classNames from "classnames";

const ActionButtonsGroup = ({
  onCancel,
  onSave,
  onSaveDisabled = null,
  cancelLabel = "Cancel",
  saveLabel = "Save Changes",
  saveDisabled: saveDisabledd = false,
  cancelDisabled = false,
  buttonSize = "medium",
  bgColorClass = "bg-white",
}) => {
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (saveDisabledd && onSaveDisabled) {
      onSaveDisabled();
      return;
    }

    if (saveDisabledd || isSaving) return;

    setIsSaving(true);
    try {
      await onSave();
    } finally {
      setIsSaving(false);
    }
  };

  const sizeClasses = {
    small: "min-h-[10px] min-w-[80px] px-2 py-2 text-sm rounded-[28px]",
    medium: "min-h-[40px] min-w-[180px] px-4 py-3 text-base rounded-[42px]",
    large: "min-h-[48px] min-w-[240px] px-5 py-4 text-lg rounded-[56px]",
  };

  const saveBtnClass = classNames(
    "text-white flex items-center justify-center",
    sizeClasses[buttonSize],
    {
      "hover:bg-main-blue hover:bg-gradient-to-b hover:from-blue-300 hover:to-main-blue":
        !saveDisabledd && !isSaving,
      "cursor-not-allowed": (saveDisabledd && !onSaveDisabled) || isSaving,
      "bg-gray-400": saveDisabledd || isSaving,
      "bg-main-blue": !saveDisabledd && !isSaving,
      "cursor-pointer": (!saveDisabledd || onSaveDisabled) && !isSaving,
    }
  );

  const cancelBtnClass = classNames(
    "flex items-center justify-center border-2 border-solid",
    sizeClasses[buttonSize],
    {
      "cursor-not-allowed": cancelDisabled || isSaving,
      "border-blue-400": !cancelDisabled,
      "border-main-gray": cancelDisabled,
      "text-[#1DA1F2]": !cancelDisabled,
      "text-main-gray": cancelDisabled,
      "cursor-pointer": !cancelDisabled,
    }
  );

  return (
    <div className="flex flex-col px-5 justify-center w-full text-xl tracking-wide leading-none text-neutral-900 max-md:max-w-full">
      <div className={`flex flex-wrap gap-5 justify-center items-center text-base font-semibold tracking-tight leading-none text-center ${bgColorClass} sm:flex-row sm:gap-5 md:gap-5 max-w-full`}>
        {onCancel && (
          <button
            onClick={onCancel}
            className={cancelBtnClass}
            disabled={cancelDisabled}
          >
            <div className="bg-clip-text bg-[linear-gradient(180deg,#5EC2FF_0%,#1DA1F2_100%)]">
              {cancelLabel}
            </div>
          </button>
        )}
        <button
          onClick={handleSave}
          className={saveBtnClass}
          disabled={!onSaveDisabled && (saveDisabledd || isSaving)}
        >
          {isSaving ? (
            <div className="flex items-center space-x-2">
              <span className="loader border-t-2 border-white rounded-full w-5 h-5 animate-spin"></span>
              <span>Loading...</span>
            </div>
          ) : (
            saveLabel
          )}
        </button>
      </div>
    </div>
  );
};

export default ActionButtonsGroup;